import { CommonModule } from '@angular/common';
import { Component, OnInit } from "@angular/core";
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { AppTitleService, AuthService, HasPermissionDirective, SideNavComponent } from "@fourcomply-dashboard/shared";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
// import { PanelModule, PanelSide } from '@verizon/ngx-panels';
import { BreadcrumbComponent, BreadcrumbService } from "xng-breadcrumb";
import { HeaderComponent } from './shared/components/header/header.component';
import { AiPanelComponent } from './shared/components/ai-panel/ai-panel.component';

@Component({
  imports: [
    AiPanelComponent,
    BreadcrumbComponent,
    CommonModule,
    HasPermissionDirective,
    HeaderComponent,
    MatSidenavModule,
    // PanelModule.forRoot({ side: PanelSide.RIGHT, size: 600 }),
    RouterOutlet,
    SideNavComponent,
    TranslateModule
  ],
  selector: "app-root",
  standalone: true,
  styleUrls: ["app.component.scss"],
  templateUrl: "app.component.html"
})
export class AppComponent implements OnInit {
  navOpen = true;
  userEmail: string;
  showBreadCrumb = false;

  constructor(
    private appTitleService: AppTitleService,
    public auth: AuthService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public translate: TranslateService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang("en");
    translate.addLangs(["en", "fr"]);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use("en");

    breadcrumbService.breadcrumbs$.subscribe((x) => {
      if (x.length >= 3) {
        this.showBreadCrumb = true;
      } else {
        this.showBreadCrumb = false;
      }
    });
  }

  initTranslation() {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang("en");
    this.translate.addLangs(["en", "fr"]);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use("en");
  }

  ngOnInit() {
    // Initialize Auth0 client on app startup
    this.auth.localAuthSetup();
    
    this.initIntercom();
    this.initTranslation();

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  initIntercom() {
    // Intercom rejects non-registered origins (403 on ping/launcher_settings),
    // so skip booting it on local dev servers.
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
      return;
    }
    window.Intercom = window.Intercom || {};
    window.Intercom("boot", {
      app_id: "r2twb3rv",
    });
  }
}
